import type { Column, ColumnDef } from "@tanstack/react-table";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { TableCell, TableRow } from "@volca/ui/components/ui/table";
import { cn } from "@volca/ui/lib/utils";
import { cellClasses, getPinningStyles, ROW_CLASSES } from "./styles";

interface SimpleTableLoadingRowsProps<TData> {
  columns: ColumnDef<TData, unknown>[];
  columnPinning?: { left?: string[]; right?: string[] };
  loadingRowCount: number;
}

export const SimpleTableLoadingRows = <TData,>({
  columns,
  columnPinning,
  loadingRowCount,
}: SimpleTableLoadingRowsProps<TData>) =>
  Array.from({ length: loadingRowCount }).map((_, index) => (
    <TableRow
      key={`loading-row-${index}`}
      aria-hidden
      className={cn(ROW_CLASSES, "h-18 w-full")}
    >
      {columns.map((column, cellIndex) => {
        const dummyColumn = {
          columnDef: column,
          getIsPinned: () =>
            column.id === "actions" && columnPinning?.right?.includes("actions")
              ? "right"
              : false,
          getIsLastColumn: () => false,
          getIsFirstColumn: () =>
            column.id === "actions" &&
            columnPinning?.right?.includes("actions"),
          getStart: () => 0,
          getAfter: () => 0,
        };

        return (
          <TableCell
            key={`loading-cell-${cellIndex}`}
            style={getPinningStyles(dummyColumn as unknown as Column<TData>)}
            className={cellClasses(index >= loadingRowCount - 1)}
          >
            <Skeleton className="h-6 w-full max-w-[100px]" />
          </TableCell>
        );
      })}
    </TableRow>
  ));
